export default __webpack_public_path__ + "static/media/Image-20.df5176b8.jpg";